module.exports = __webpack_public_path__ + "static/media/mode-45.98c86ea0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-45.svg
// module id = 1017
// module chunks = 2